import React, { useState } from 'react';
import { BellIcon, PlusIcon, TrashIcon, EditIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const MyAlertsPage = () => {
  const [activeTab, setActiveTab] = useState('active');
  return <div className="container mx-auto px-4 py-8" data-id="element-204">
      <div className="flex justify-between items-center mb-6" data-id="element-205">
        <h1 className="text-3xl font-bold" data-id="element-206">My Flight Alerts</h1>
        <Link to="/alerts" className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-md transition-colors" data-id="element-207">
          <PlusIcon className="h-5 w-5 mr-2" data-id="element-208" />
          New Alert
        </Link>
      </div>
      <div className="flex space-x-4 mb-6" data-id="element-209">
        <button className={`px-4 py-2 rounded-md ${activeTab === 'active' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setActiveTab('active')} data-id="element-210">
          Active Alerts (
          {mockAlerts.filter(a => a.status === 'active').length})
        </button>
        <button className={`px-4 py-2 rounded-md ${activeTab === 'past' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} onClick={() => setActiveTab('past')} data-id="element-211">
          Past Alerts (
          {mockAlerts.filter(a => a.status === 'completed').length})
        </button>
      </div>
      <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-212">
        {activeTab === 'active' && mockAlerts.filter(a => a.status === 'active').length === 0 ? <div className="p-8 text-center" data-id="element-213">
            <BellIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" data-id="element-214" />
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-215">
              No Active Alerts
            </h3>
            <p className="text-gray-500 mb-4" data-id="element-216">
              You don't have any active flight alerts set up.
            </p>
            <Link to="/alerts" className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-md transition-colors" data-id="element-217">
              <PlusIcon className="h-5 w-5 mr-2" data-id="element-218" />
              Create Your First Alert
            </Link>
          </div> : <div className="overflow-x-auto" data-id="element-219">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-220">
              <thead className="bg-gray-50" data-id="element-221">
                <tr data-id="element-222">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-223">
                    Flight Details
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-224">
                    Alert Type
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-225">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-226">
                    Notifications
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-227">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-228">
                {mockAlerts.filter(alert => activeTab === 'active' ? alert.status === 'active' : alert.status === 'completed').map(alert => <tr key={alert.id} className="hover:bg-gray-50" data-id="element-229">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-230">
                        <div className="flex items-center" data-id="element-231">
                          <div className="h-10 w-10 flex-shrink-0" data-id="element-232">
                            <img className="h-10 w-10 rounded-full" src={alert.airlineLogo} alt={alert.airline} data-id="element-233" />
                          </div>
                          <div className="ml-4" data-id="element-234">
                            <div className="text-sm font-medium text-gray-900" data-id="element-235">
                              {alert.flightNumber}
                            </div>
                            <div className="text-sm text-gray-500" data-id="element-236">
                              {alert.route}
                            </div>
                            <div className="text-sm text-gray-500" data-id="element-237">
                              {alert.date}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-238">
                        <ul className="text-sm text-gray-500" data-id="element-239">
                          {alert.alertTypes.map((type, index) => <li key={index} data-id="element-240">• {type}</li>)}
                        </ul>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-241">
                        {alert.status === 'active' ? <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-242">
                            Active
                          </span> : <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-243">
                            Completed
                          </span>}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-244">
                        <div className="flex flex-col" data-id="element-245">
                          {alert.notificationMethods.map((method, index) => <div key={index} className="flex items-center text-sm text-gray-500" data-id="element-246">
                              <CheckCircleIcon className="h-4 w-4 mr-1 text-green-500" data-id="element-247" />
                              {method}
                            </div>)}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-248">
                        <div className="flex space-x-3" data-id="element-249">
                          <button className="text-blue-600 hover:text-blue-900" data-id="element-250">
                            <EditIcon className="h-5 w-5" data-id="element-251" />
                          </button>
                          <button className="text-red-600 hover:text-red-900" data-id="element-252">
                            <TrashIcon className="h-5 w-5" data-id="element-253" />
                          </button>
                        </div>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
      {activeTab === 'active' && mockAlerts.filter(a => a.status === 'active').length > 0 && <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-254">
            <div className="flex" data-id="element-255">
              <div className="flex-shrink-0" data-id="element-256">
                <AlertCircleIcon className="h-5 w-5 text-blue-400" data-id="element-257" />
              </div>
              <div className="ml-3" data-id="element-258">
                <h3 className="text-sm font-medium text-blue-800" data-id="element-259">
                  About Flight Alerts
                </h3>
                <div className="mt-2 text-sm text-blue-700" data-id="element-260">
                  <p data-id="element-261">
                    You'll receive notifications based on your alert
                    preferences. Alerts automatically expire 24 hours after the
                    scheduled arrival time.
                  </p>
                </div>
              </div>
            </div>
          </div>}
    </div>;
};
// Mock alert data
const mockAlerts = [{
  id: 1,
  flightNumber: 'AA1234',
  airline: 'American Airlines',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/American-Airlines-Logo-700x394.png',
  route: 'JFK → LAX',
  date: 'May 15, 2023',
  alertTypes: ['Status Changes', 'Gate Changes', 'Departure Updates'],
  notificationMethods: ['Email', 'SMS'],
  status: 'active'
}, {
  id: 2,
  flightNumber: 'DL5678',
  airline: 'Delta Air Lines',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/Delta-Air-Lines-Logo-700x394.png',
  route: 'ATL → ORD',
  date: 'May 20, 2023',
  alertTypes: ['Status Changes', 'Arrival Updates'],
  notificationMethods: ['Email'],
  status: 'active'
}, {
  id: 3,
  flightNumber: 'UA9012',
  airline: 'United Airlines',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/United-Airlines-Logo-700x394.png',
  route: 'SFO → SEA',
  date: 'April 30, 2023',
  alertTypes: ['Status Changes', 'Gate Changes', 'Baggage Claim'],
  notificationMethods: ['Email', 'Push Notification'],
  status: 'completed'
}, {
  id: 4,
  flightNumber: 'BA3456',
  airline: 'British Airways',
  airlineLogo: 'https://logos-world.net/wp-content/uploads/2020/03/British-Airways-Logo-700x394.png',
  route: 'LHR → JFK',
  date: 'April 25, 2023',
  alertTypes: ['Status Changes', 'Weather Alerts'],
  notificationMethods: ['Email', 'SMS'],
  status: 'completed'
}];
export default MyAlertsPage;